function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { convertStyleValue } from '../../utils/js-style-to-css';
import { getColor } from '../Theme/selectors';

/**
 * Returns a composed linear gradient css attribute from given angle and
 * colour stops.
 *
 * @param {number} The angle of the gradient.
 * @param {array} An array of gradient colour stops `[[percent, colour], [percent, colour], ...]`
 *
 * @returns {string}
 */
var formatLinearGradientString = function formatLinearGradientString(angle, stops, uiTheme) {
  var sortedStops = stops.slice().sort(function (a, b) {
    if (a[0] > b[0]) return 1;
    if (a[0] < b[0]) return -1;
    return 0;
  }).map(function (stop) {
    var _stop = _slicedToArray(stop, 2),
      location = _stop[0],
      color = _stop[1];
    return "".concat(getColor(uiTheme, color), " ").concat(convertStyleValue(location));
  }).join(',');
  return "linear-gradient(".concat(angle, "deg, ").concat(sortedStops, ")");
};
var linearGradientPropsToCss = function linearGradientPropsToCss(_ref) {
  var angle = _ref.angle,
    stops = _ref.stops,
    uiTheme = _ref.uiTheme;
  return "\n    ".concat("background: ".concat(formatLinearGradientString(angle, stops, uiTheme), ";"), "\n  ");
};
export default linearGradientPropsToCss;